import styled from 'styled-components';
import Button from 'components/Button';
import COLORS from 'shared/constants/colors';

export const Container = styled.div`
  margin: 20px;
`;

export const Header = styled.div`
  border-bottom: 1px solid #676a6c;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  padding-bottom: 10px;
  justify-content: space-between;
`;

export const Title = styled.h1`
  margin: 0;
`;

export const Filter = styled.div`
  display: flex;
  gap: 20px;
  .MuiFormControl-root {
    width: 100px;
  }

  button {
    background-color: #000000;
    color: #ffffff;
    box-shadow: none;
    :hover {
      background-color: #000000;
      color: #ffffff;
      box-shadow: none;
    }
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const OrderWrapper = styled.div`
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  display: grid;
  grid-gap: 20px;
`;
export const OrderCard = styled.div`
  background: ${COLORS.WHITE};
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px ${COLORS.WHITE};
  padding: 30px 15px 15px 15px;
  border-radius: 4px;
  position: relative;
  transition: all ease-out 0.25s;
  border: 1px solid transparent;
  max-width: 300px;
  :hover {
    cursor: pointer;
    box-shadow: 0px 10px 10px #d9d9d9, -5px -5px 10px #ffffff;
    background: #f2f2f2;
  }
`;

export const Status = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-weight: bold;
  background: ${(props) =>
    props?.approved || props?.processed || props?.shipped
      ? 'green'
      : props?.declined
      ? 'red'
      : 'orange'};
  color: white;
  padding: 5px;
`;

export const Row = styled.div`
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
`;

export const RowHeader = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const SubRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  .src {
    background-image: url(https://developer.android.com/reference/android/images/graphics/composite_CLEAR.png?hl=vi);
    display: flex;
    background-size: 50%;
  }

  img {
    width: 150px;
  }
`;

export const RowFooter = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0;
  justify-content: flex-end;

  button {
    color: white;
    background-color: black;

    :hover {
      color: white;
    }

    &.approve {
      background-color: green;
      :hover {
        background-color: green;
      }
    }

    &.declined {
      background-color: red;
      :hover {
        background-color: red;
      }
    }
  }
`;

export const DownloadArtFileButton = styled(Button)`
  background-color: #000000;
  color: #ffffff;
  font-size: 10px;
  :hover {
    background-color: #000000;
    color: #ffffff;
  }
`;
